<div soho class="{{cardClasses}}"
  attr.id="{{panel.id + '_widget'}}"
  attr.data-automation-id="lm-{{panel.automationId}}-widget"
  >
  <div class="card-header">
    <h2
      [ngStyle]="{'display': 'inline-block'}"
      [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText), 'widget-title': true}"
      attr.id="{{panel.id}}_widget_title"
      attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
      ><lm-widget-title [title]="panel.title"></lm-widget-title></h2>

      @if (!drillAroundWindow) {
        <div class="panelNavigation">
          @if (hasOverviewNavigation && !displayLinkAsText) {
            <button
              soho-button="icon"
              icon="right-arrow"
              soho-tooltip [content]="overNavigationLink"
              (click)="onNavigationClick($event)"
              attr.id="{{panel.id}}_overview_navigation"
              attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
            ></button>
          }
          @if (displayLinkAsText) {
            <a
              attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
              soho-hyperlink
              class="lm-hyperlink"
              (click)="onNavigationClick($event)"
              soho-tooltip [content]="overNavigationLink"
              attr.id="{{panel.id}}_overview_navigation"
              attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
            >{{overNavigationLink}}</a>
          }
        </div>
      }
    </div>

    @if (panel.formSpec && fromDataView && panel.type !== 'menuPanel') {
      <div [ngStyle]="{'padding-top': '10px'}" class="card-content">
        <lm-form-content-template
          [fromDataView]="fromDataView"
          [sourceDataView]="fromDataView"
          [formUrlInfo]="formUrlInfo"
          [formSpec]="panel.formSpec"
          [placeHolder]="placeHolder"
          [specFields]="panel.formSpec.busFormSpec.fields"
          [formOptions]="{isDashBoardContent: true}"
          [layout]="panel.layout"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-form-content-template>
      </div>
    }

  </div>
